import { MapPin, Navigation } from "lucide-react";

const BARANGAY = "Barangay Mabuhay, General Santos City";

export const gkkQuery = (g) => (g.lat && g.lng ? `${g.lat},${g.lng}` : `${g.address}`);

export const directionsUrl = (g) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(gkkQuery(g))}`;

const embedUrl = (q, zoom) =>
  `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=${zoom}&output=embed`;

export default function GKKMap({ selected, onClear }) {
  const src = selected ? embedUrl(gkkQuery(selected), 16) : embedUrl(BARANGAY, 14);
  return (
    <div id="gkk-map" data-testid="gkk-map" className="mt-10 grid lg:grid-cols-12 border border-cocoa-900/15 bg-parchment-100 scroll-mt-28">
      <div className="lg:col-span-4 p-8 flex flex-col justify-between gap-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-sage-dark font-sans mb-3">Parish Map</div>
          {selected ? (
            <>
              <h3 data-testid="gkk-map-title" className="font-serif text-2xl text-cocoa-900 leading-snug">GKK {selected.patron}</h3>
              <p className="mt-2 flex gap-1.5 text-sm text-cocoa-700 font-sans">
                <MapPin size={14} className="mt-0.5 shrink-0" /> {selected.address}
              </p>
              {!selected.lat && (
                <p className="mt-3 text-[11px] italic text-cocoa-700/70 font-sans">Location is approximate, based on the address.</p>
              )}
            </>
          ) : (
            <>
              <h3 data-testid="gkk-map-title" className="font-serif text-2xl text-cocoa-900 leading-snug">Barangay Mabuhay</h3>
              <p className="mt-2 text-sm text-cocoa-700 font-sans leading-relaxed">
                Tap <strong className="font-medium">Show on map</strong> on any GKK below to find its community, or get turn-by-turn directions.
              </p>
            </>
          )}
        </div>
        {selected && (
          <div className="flex flex-wrap gap-3">
            <a href={directionsUrl(selected)} target="_blank" rel="noopener noreferrer" data-testid="gkk-map-directions" className="inline-flex items-center gap-2 bg-cocoa-900 text-parchment-100 px-5 py-2.5 text-[11px] uppercase tracking-[0.2em] font-sans hover:bg-terracotta transition-colors">
              <Navigation size={13} /> Get Directions
            </a>
            <button onClick={onClear} data-testid="gkk-map-reset" className="text-[11px] uppercase tracking-[0.2em] text-cocoa-700 hover:text-terracotta font-sans">
              Whole parish
            </button>
          </div>
        )}
      </div>
      <iframe
        key={src}
        title="GKK map"
        src={src}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="lg:col-span-8 w-full h-[340px] md:h-[420px] border-0"
      />
    </div>
  );
}
